import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Section, Eyebrow, FadeIn } from "../../components/public/Section";
import { PageHero } from "./About";
import * as Icons from "lucide-react";

const FALLBACK = [
  { slug: "coffee-bar", title: "Luxury Coffee Bar", icon: "Coffee" },
  { slug: "tea-lounge", title: "Premium Tea Lounge", icon: "Leaf" },
  { slug: "cocktail-counter", title: "Cocktail Counter", icon: "Wine" },
  { slug: "mocktail-counter", title: "Mocktail Counter", icon: "GlassWater" },
  { slug: "chocolate-fountain", title: "Chocolate Fountain", icon: "Droplet" },
  { slug: "live-pizza", title: "Live Pizza Station", icon: "Pizza" },
  { slug: "live-pasta", title: "Live Pasta Station", icon: "UtensilsCrossed" },
  { slug: "live-chaat", title: "Live Chaat Counter", icon: "Soup" },
  { slug: "dessert-studio", title: "Dessert Studio", icon: "Cake" },
];

export default function SpecialSetups() {
  const [items, setItems] = useState(FALLBACK);
  useEffect(() => {
    api.get("/public/site").then(r => { if (r.data?.special_setups?.length) setItems(r.data.special_setups); });
  }, []);
  return (
    <>
      <PageHero title="Special Setups" subtitle="Theatre meets tradition — counters that become the stars of your evening." image="https://images.unsplash.com/photo-1558996338-294a904a1815?auto=format&fit=crop&w=2000&q=80" />
      <Section>
        <Eyebrow>Live & Themed Counters</Eyebrow>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">
          {items.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <FadeIn key={s.slug || i} delay={i * 0.05}>
                <div className="border border-navy-900/15 p-8 hover:border-gold transition bg-white royal-card" data-testid={`setup-${s.slug}`}>
                  <div className="w-14 h-14 rounded-full bg-navy-900 flex items-center justify-center mb-5"><Icon size={22} className="text-gold" strokeWidth={1.5} /></div>
                  <div className="serif text-2xl">{s.title}</div>
                  <div className="text-navy-900/60 text-sm mt-2">{s.description || "Crafted live for your guests — chef-led, theatrical, unforgettable."}</div>
                </div>
              </FadeIn>
            );
          })}
        </div>
      </Section>
    </>
  );
}
